$('document').ready(function(){

    let implementAccordion = () => { 
        let accordionHeadings = document.querySelectorAll(".accordion-title"),
            accordionContent = document.querySelectorAll('.accordion-content');
        hidePanels(accordionHeadings, accordionContent);
        accordionHeadings.forEach((heading) => {
            heading.addEventListener('click', (e)=>{
            let heading = e.currentTarget;
            (heading.nextElementSibling.style.maxHeight)? hidePanels() : showPanel(heading, accordionHeadings, accordionContent);
            })
        })
    },
    showPanel = (element, accordionHeadings, accordionContent) => {
        hidePanels(accordionHeadings, accordionContent);
        element.classList.add("active");
        element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + "px";
    },
    hidePanels = (accordionHeadings, accordionContent) => {
        accordionHeadings.forEach((heading, index) => {
            accordionContent[index].style.maxHeight = null;
            heading.classList.remove('active');
        });
    },
    ShopPayPopupQuickview = () => {
        $("#shop-pay-popup-link").removeAttr('target');

        $("#shop-pay-popup-link").click(function () {
            if ($('#shop-pay-popup').length == 0){$("body").prepend('<div id="shop-pay-popup"></div>');}
            var sku=$('.product-meta__sku-number').text();
            $.fancybox({
            href: '#shop-pay-popup',
            maxWidth: 1040,
            maxHeight: 750,
            fitToView: true,
            width: '75%',
            height: '85%',
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            'beforeLoad': function () {
                $('.fancybox-wrap').css('overflow', 'hidden !important');
            },
            'afterShow': function () {
                $('#shop-pay-popup').closest('.fancybox-inner').addClass('shop-pay-fancybox-container');
                $('#shop-pay-popup').closest('.fancybox-wrap').addClass('shop-pay-fancybox-container');
                $('#shop-pay-popup').hide().html(shopPayPopupContent).css('opacity', '1').fadeIn(function () {
                });
                document.querySelectorAll('.shop-pay-fancybox-container').forEach((popup)=>{
                    let style=popup.getAttribute('style');
                    style+='overflow-y: scroll !important;';
                    popup.setAttribute('style', style);
                })
                // implementAccordion();
            },
            'afterClose': function () {
                $('#shop-pay-popup').removeClass().empty();
            }
            });
        })
    },
    init = () => {
        ShopPayPopupQuickview();
    };
    $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
        console.log('hello')
        init();
    });
})